/*
 * HelpScreen5
 * ==========
 */
import HelpBase from '../ui/HelpBase'

export default class HelpScreen5 extends HelpBase {

  constructor (game, screens) {
    super(game);

    this.screens = screens;

    this.page = 5;

    this.params = {

      'helpBombTextP': [-2, -170],
      'helpBombGridP': [-25, 23],
      'helpBombUiP': [-6, -336],
      'helpBombTextL': [50, -160],
      'helpBombGridL': [55, 27],
      'helpBombUiL': [-255, 73],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, 203],
      'nextP': [107, 203],
      'exitP': [2, 203]

    };

    this.helpBombTextP = this.addSprite('helpBombTextP', 'helpScreens', 'helpBombText.png', 'p');
    this.helpBombGridP = this.addSprite('helpBombGridP', 'helpScreens', 'helpBombGrid.png', 'p');
    this.helpBombUiP = this.addSprite('helpBombUiP', 'helpScreens', 'helpBombUi.png', 'p');

    this.helpBombTextL = this.addSprite('helpBombTextL', 'helpScreens', 'helpBombText.png', 'l');
    this.helpBombGridL = this.addSprite('helpBombGridL', 'helpScreens', 'helpBombGrid.png', 'l');
    this.helpBombUiL = this.addSprite('helpBombUiL', 'helpScreens', 'helpBombUi.png', 'l');

    this.helpBombUiL.scale.set(0.9);

    this.initHelpButtons(false, true);

    this.setInputForAllButtons(false)
  }

}
